import React from 'react';
import { CATEGORY_REGISTRY } from '../ai/registry/categoryRegistry';

function NaturalLanguageForm({ input, setInput, loading, onSubmit, selectedCategory, onClearCategory }) {
  const activeCat = selectedCategory
    ? CATEGORY_REGISTRY.find(c => c.id === selectedCategory)
    : null;

  return (
    <form onSubmit={onSubmit} style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 8 }}>
      {activeCat && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
          <span style={{ color: '#64748b', fontSize: 12, textTransform: 'uppercase', letterSpacing: 0.8 }}>
            Domain scope
          </span>
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 5,
              padding: '3px 10px',
              borderRadius: 12,
              border: '1px solid #f43f5e',
              background: 'rgba(244,63,94,0.1)',
              color: '#f43f5e',
              fontSize: 12,
              fontWeight: 600,
            }}
          >
            {activeCat.icon} {activeCat.label}
            {activeCat.domains.length > 1 && (
              <span style={{ color: '#94a3b8', fontWeight: 400, fontSize: 11 }}>
                {' '}({activeCat.domains.join(' + ')})
              </span>
            )}
            <button
              type="button"
              onClick={onClearCategory}
              style={{
                marginLeft: 4,
                background: 'none',
                border: 'none',
                color: '#94a3b8',
                cursor: 'pointer',
                padding: 0,
                fontSize: 13,
                lineHeight: 1,
              }}
              title="Clear category"
            >
              ✕
            </button>
          </span>
        </div>
      )}
      <textarea
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder={
          activeCat
            ? `Describe your ${activeCat.label.toLowerCase()} goal... e.g. "${activeCat.example}"`
            : 'Describe your materials discovery goal...'
        }
        rows={6}
        style={{ width: '100%' }}
      />
      <button type="submit" disabled={loading || !input.trim()}>
        {loading ? 'Working...' : 'Run'}
      </button>
    </form>
  );
}

export default NaturalLanguageForm;
